module.exports = __webpack_public_path__ + "static/media/Facebook.107a18d2.svg";